import { signin, me, ready, verify } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    id: null,
    name: '',
    email: '',
    level: null,
    //        avatar: '',
    //        role: '',
    //        centrifugo_token: '',
    //        centrifugo_timestamp: null,
    //        centrifugo_info: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_LEVEL: (state, level) => {
      state.level = level
    },
  },

  actions: {
    // 登录
    authSignin({ commit }, userInfo) {
      const email = userInfo.email.trim()
      return new Promise((resolve, reject) => {
        signin(email, userInfo.password).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    authMe({ commit, state }) {
      return new Promise((resolve, reject) => {
        me().then(response => {
          const data = response.data
          console.log(data)
          commit('SET_ID', data.id)
          commit('SET_EMAIL', data.email)
          commit('SET_NAME', data.name)
          commit('SET_LEVEL', data.level)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    authSignout({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ID', '')
        commit('SET_EMAIL', '')
        commit('SET_NAME', '')
        commit('SET_LEVEL', '')
        removeToken()
        resolve()
      })
    },

    // 前端 登出
    authFedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 前端 登出
    authActivateAccount({ commit }, userInfo) {
      userInfo.onetimepasswordType = 'activate-account'
      return new Promise((resolve, reject) => {
        ready(userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    authVerify({ commit }) {
      let params = new URLSearchParams(location.search)

      const email = params.get('email')
      const onetimepassword = params.get('onetimepassword')

      return new Promise((resolve, reject) => {
        if (!email || !onetimepassword) {
          resolve()
        } else {
          verify({
            email: email,
            onetimepassword: onetimepassword
          }).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
  }
}

export default user
